var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "blog",
    viewBox: "0 0 640 640",
    fill: "none",
    stroke: "#666",
    strokeWidth: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M609.8,460.9C614.9,351.7,565,193,551,171c-9.9-15.6-33.1-27.6-36.3-28.9c-26.4-10.1-62.2-29.8-90.5,2.1c-14,15.8-33.9,22.8-55,22.8h-102c-18.8,0-36.7-8.2-48.6-22.6c-27.8-33.8-65.1-11.9-92.4-1.9c-5.7,2.1-24.8,13.8-32.1,28.3C85.6,188,29.6,357.1,29.8,460.9c0.1,26.5,46.9,90.4,102.1,23.1l25.3-37c13-19.1,34.2-31.3,57.3-31.9c0.9,0,209.8,0,210.6,0c22.6,0.7,43.6,12.1,57.2,30.2l28.4,38.9C565.9,548,608.6,487.3,609.8,460.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame);
export default __webpack_public_path__ + "static/media/game.cec1a796ccc14e76780764682aebbfb8.svg";
export { ForwardRef as ReactComponent };